import React, { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import Sidebar, { MobileTopbar } from "@/components/Sidebar";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/context/I18nContext";
import { Languages } from "lucide-react";

function LayoutInner() {
  const { user, loading } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const { lang, setLang, canToggle } = useT();

  if (loading) return <div className="flex items-center justify-center min-h-screen">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.status === "profile_incomplete" || (user.status === "pending" && !user.chapter_id)) {
    return <Navigate to="/complete-signup" replace />;
  }
  if (user.status === "pending") {
    return <Navigate to="/complete-signup" replace />;
  }
  if (user.must_change_password) {
    return <Navigate to="/change-password" replace />;
  }

  return (
    <div className="flex min-h-screen">
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} lang={lang} />
      <div className="flex-1 min-w-0">
        <MobileTopbar setMobileOpen={setMobileOpen} lang={lang} setLang={setLang} canToggle={canToggle} />
        {canToggle && <div className="hidden lg:flex items-center justify-end px-8 pt-6">
          <button
            onClick={() => setLang(lang === "hy" ? "en" : "hy")}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-border bg-white/60 hover:bg-white text-xs font-bold uppercase tracking-wider"
            data-testid="lang-toggle"
          >
            <Languages size={14} /> {lang === "hy" ? "English" : "Հայերեն"}
          </button>
        </div>}
        <main className="p-4 lg:p-8 max-w-[1400px] mx-auto">
          <Outlet context={{ lang }} />
        </main>
      </div>
    </div>
  );
}

export default function Layout() {
  return <LayoutInner />;
}
